const products_on_page = document.getElementById('product-grid');
const nextUrlElement = document.getElementById('paginateNext');
let next_url = nextUrlElement ? nextUrlElement.dataset.nextUrl : null;

const load_more_btn = document.querySelector('.load-more_btn');
const load_more_spinner = document.querySelector('.load-more_spinner');

async function getNextPage() {
  try {
    const res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.error('Error loading next page:', error);
  }
}

async function loadMoreProducts() {
  if (!next_url) return;

  // Hide button, show spinner
  load_more_btn.classList.add('hidden');
  load_more_spinner.classList.remove('hidden');

  // Fetch next page HTML
  const nextPage = await getNextPage();

  // Parse HTML string to DOM
  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  // Hide spinner after content loads
  load_more_spinner.classList.add('hidden');

  // Extract products and pagination from next page
  const productgrid = nextPageDoc.getElementById('product-grid');
  const new_products = productgrid ? productgrid.getElementsByClassName('grid__item') : [];

  const newUrlElement = nextPageDoc.getElementById('paginateNext');
  next_url = newUrlElement ? newUrlElement.dataset.nextUrl : null;

  // Append new products
  for (let i = 0; i < new_products.length; i++) {
    products_on_page.appendChild(new_products[i]);
  }

  // Show button again if more pages exist
  if (next_url) {
    load_more_btn.classList.remove('hidden');
  } else {
    load_more_btn.classList.add('hidden'); // hide permanently when last page is reached
  }
}
